export const LANDING = 'cp_landing'
export const WIZARD = 'cp_wizard'
